import { useEffect, useState } from 'react';

import { msUntilCentralMidnight } from 'components/Streaks/model/centralTime';
import { LAST_CALL_MS } from 'components/Streaks/model/deriveView';

/**
 * "Now" for the streak surfaces, re-rendered only when the display can change:
 * once when last call starts (2 h before midnight CT), once a minute during
 * last call (the "1h 52m left" text), and at midnight. Most of the day no
 * timer is pending at all beyond the one wake-up.
 */
export function useStreakClock(active: boolean): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return undefined;
    const left = msUntilCentralMidnight(now);
    let wait: number;
    if (left > LAST_CALL_MS) wait = left - LAST_CALL_MS;
    else wait = Math.min(left, 60_000 - (now % 60_000)) + 50;
    const id = window.setTimeout(() => setNow(Date.now()), Math.max(1000, wait));
    return () => window.clearTimeout(id);
  }, [active, now]);
  return now;
}
